import fetchClient from "./index";
import { BASE_URL, endPoints } from "./urls";

export const socialLinks = async () => {
  try {
    const response = await fetchClient().get(
      `${BASE_URL}${endPoints.SOCIAL_LINKS}`
    );
    return response;
  } catch (error) {
    console.log("error", error);
    return error;
  }
};
